import { Box, TextField, Typography } from "@mui/material";
import { min } from "lodash";
import React, { FC, FocusEvent } from "react";
import { useTranslation } from "react-i18next";

import {colors} from "../config/colors";
import {
  NUMBER_OF_LINES,
} from "../config/constants";

interface MessageBoxProps {
  text: string;
  setText: (value: string) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  editing?: boolean;
  minChars?: number;
  maxChars?: number;
  placeholder?:string;
  showFooterText?:boolean
}

const MessageBox: FC<MessageBoxProps> = ({
  text,
  setText,
  onFocus = () => {
      // Do nothing
  },
  onBlur = () => {
      // Do nothing
  },
  placeholder = undefined,
  editing = true,
  minChars = 0,
  maxChars = 255,
  showFooterText= true,
}) => {
  const {t} = useTranslation();
  const footnoteText = minChars
    ? t("message-box_text-limit-message", {minChars, maxChars})
    : t("message-box_max-text-limit-message", {maxCharsLimit: maxChars});

  const handleTextChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newText = e.target.value;
    if (maxChars >= newText.length) {
      setText(newText);
    }
  };

  return (
    <Box width="100%">
      <TextField
        label= {placeholder ?? "Message"}
        value={text}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={handleTextChange}
        variant="filled"
        multiline
        minRows={NUMBER_OF_LINES}
        maxRows={5}
        fullWidth
        InputProps={{
          style: {
            backgroundColor: colors.fieldBackground,
            borderRadius: "4px 4px 0 0",
            borderBottomWidth: "1px",
            borderBottomColor: colors.inactiveFieldBorder,
          },
        }}
        InputLabelProps={{
          style: {
            color: colors.fieldText,
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderBottom: editing
                ? `1px solid ${colors.activeFieldBorder}`
                : "none",
            },
          },
        }}
      />
     {showFooterText &&  <Typography
        sx={{
          color: colors.fieldText,
          paddingTop: "4px",
          paddingX: "16px",
          fontSize: "12px",
          lineHeight: "16px",
        }}
      >
        {footnoteText}
      </Typography> }
    </Box>
  );
};

export default MessageBox;
